import { BaseComponent } from '../../base-component';
import { ImagesSubComponent } from './images.sub.component';
import { AlternateImagesSubComponent } from './alternate-images/alternate-images.sub.component';
import { MainImageSubComponent } from './main-image/main-image.sub.component';
import { LightboxSubComponent } from './lightbox/lightbox.sub.component';
import { VideoLinkSubComponent } from './video-link/video-link.sub.component';
import { ComboPromoButtonSubComponent } from './combo-promo-button/combo-promo-button.sub.component';

export class ImagesComponent extends BaseComponent {
    public rootSelector = '.js_pdp_images';
    private subComponents: ImagesSubComponent[] = [];

    private async addSubComponent(subComponent: ImagesSubComponent) {
        if (this.logger) {
            await subComponent.setLogger(this.logger);
        }
        this.subComponents.push(subComponent);
    }

    public async init(): Promise<void> {
        await this.addSubComponent(new MainImageSubComponent());
        await this.addSubComponent(new AlternateImagesSubComponent());
        await this.addSubComponent(new LightboxSubComponent());
        await this.addSubComponent(new ComboPromoButtonSubComponent());
        await this.addSubComponent(new VideoLinkSubComponent());

        await Promise.all(this.subComponents.map(subComponent => subComponent.init()));
    }

    public async onHtmlLoaded(): Promise<void> {
        await Promise.all(this.subComponents.map(subComponent => subComponent.onHtmlLoaded()));
        this.trackWhitespaceBelowImageModule();
        this.registerDeviceOrientationListener();
    }

    private calculateWhiteSpace(): number {
        const rootElement = this.getRootElement();
        const wrapperElement = this.getChildElement('.js_pdp_images__wrapper');
        const rootElementHeight = rootElement.getBoundingClientRect().height;
        const wrapperElementHeight = wrapperElement.getBoundingClientRect().height;
        return rootElementHeight - wrapperElementHeight;
    }

    private trackWhitespaceBelowImageModule(): void {
        this.trackView({
            'wk.product_WhiteSpace': Math.floor(this.calculateWhiteSpace()),
        });
    }

    private registerDeviceOrientationListener(): void {
        if (screen && screen.orientation) {
            screen.orientation.addEventListener('change', _event => {
                this.trackOrientationChange();
            });
        }
    }

    // public for testing
    public trackOrientationChange(): void {
        if (screen && screen.orientation && screen.orientation.type.startsWith('landscape')) {
            this.trackEvent({
                product_Zoom: 'landscape',
            });
        }
    }
}
